<template lang="html">
  <table class="table mb-0 table-striped">
    <thead class="bg-light">
      <tr>
        <th scope="col" class="border-0">#</th>
        <th scope="col" class="border-0">Nome</th>
        <th scope="col" class="border-0">Resumo</th>
        <th scope="col" class="border-0 text-center">Lançamento</th>
        <th scope="col" class="border-0 text-center">Audio</th>
        <th scope="col" class="border-0 text-center">Opções</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(row, index) in products" :key="index">
        <td>{{ row.id }}</td>
        <td class="td-4 link">
          <d-link :to="{ name: 'admin-product-edit', params: { productId: row.id }}">{{ row.name }}</d-link>
        </td>
        <td class="td-4">{{ row.excerpt }}</td>
        <td class="text-center"><i class="material-icons">{{ (row.is_new) ? 'check' : 'clear' }}</i></td>
        <td class="text-center"><i class="material-icons">{{ (row.audio) ? 'check' : 'clear' }}</i></td>
        <td class="td-2 text-center">
          <product-buttons :product="row"></product-buttons>
        </td>
      </tr>
      <tr v-if="products.length === 0">
        <td colspan="7" class="no-content">Ainda não tem nenhum produto cadastrado.</td>
      </tr>
    </tbody>
    <confirmation-modal
      :cancel="close"
      :confirm="callback"
      :title="confirmation[type].title"
      :message="confirmation[type].message"/>
  </table>
</template>

<script>
import ConfirmationModal from '_shared/ConfirmationModal.vue';
import ProductActions from './ProductActions';
import ProductButtons from './ProductButtons.vue';
import { OPTIONS_CONFIRMATION_MODAL } from './ProductModel';

export default {
  name: 'product-table',
  mixins: [ProductActions],
  components: {
    ProductButtons,
    ConfirmationModal,
  },
  props: {
    products: {
      type: Array,
    },
  },
  data() {
    return {
      type: 'product',
      object: null,
      message: null,
      confirmation: OPTIONS_CONFIRMATION_MODAL,
    };
  },
  mounted() {
  },
};
</script>

<style lang="scss" scoped>
@import '~_scss/overrides';

.td {
  &-1 {
    min-width: 100px;
  }
  &-2 {
    min-width: 120px;
  }
  &-3 {
    min-width: 170px;
  }
  &-4 {
    min-width: 300px;
  }
}
</style>
